// Scroll only the target container itself. scrollIntoView() can also move
// ancestor containers, which is surprising inside nested scroll regions.
export function scrollSelectedItemToTop(container, selector) {
  const itemEl = container.querySelector(selector);
  if (itemEl) {
    container.scrollTop = itemEl.offsetTop - container.offsetTop;
  }
}
